import triggerAnalyticsEvent, { triggerEvent } from './analytics';

function getElementDetail($element, type) {
	let detail;
	if (type === 'button') {
		detail = $element.find('button[data-target].MapAndFloorplan-button--active').data('target');
	} else {
		detail = $element.find('select[data-component]').val();
	}
	return detail;
}

const tabChange = payload => {
	triggerEvent('floorplan-module', 'tab click', getElementDetail(payload.element, payload.type));
};

export function attachAnalyticsEvents(payload) {
	const container = payload;

	container
		.find('.MapAndFloorplan-buttonsTab')
		.find('button[data-target]')
		.on('click.analytics', function () {
			triggerAnalyticsEvent(
				'mapFloorplan.tabChange',
				{
					element: container,
					type: 'button',
				},
				$(this)
			);
		});

	container
		.find('.MapAndFloorplan-dropdownContainer')
		.find('select[data-component]')
		.on('change.analytics', function () {
			triggerAnalyticsEvent(
				'mapFloorplan.tabChange',
				{
					element: container,
					type: 'dropdown',
				},
				$(this)
			);
		});
}

export default {
	tabChange,
};
